// Parshva S : 14/03/2024 : BT107070 Breeze Spread Orders Start
import { useCallback, useState, memo, useEffect, useMemo } from 'react';
import { Row, Col, Popover } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { BzPopoverOverlay, BzChip } from "../../components";
import { handleModal, handleModalData } from '../../redux/actions/modals';
import { getOrderInfo, getScripOrderInfo, getSpreadOrder, getSpreadOrderSuccess } from '../../redux/actions/orders';
import {
    convertScripResponseWatchlistGrid, getApiExchangeNameFromMktSegId, getChangeInRs,
    getDecimalLocatorFromApiExchangeName, getDynamicParamsForToFixed, getMappedMktSegIdFromApiExchangeName,
    ORDERS_GRID_REF
} from '../../utils/global_functions';
import {
    ALL_ORDERS_STATUS, ORDER_TYPES, TL_INDEX, WATCHLIST_GRID_INDEX, FACILITY_NUM, SCRIP_INSTRUMENTS,
    ORDER_STATUS_FROM_RESPONSE, MARKET_SEGMENT_ID
} from '../../utils/global_variables';
import { useWFHMessages, useLeftClick } from '../../hooks';
import { getWfhTouchlineLastTick } from '../../redux/actions/wfh';
import DontMissChip from '../DontMiss/DontMissChip';
import { sendBestFiveRequest } from '../../apis/web_socket';
import { setScripOverviewData } from '../../redux/actions/marketOverview';
import { _getScripsInfo } from '../../controllers';
import moment from 'moment';

//Maaz A : 08-11-2023 : BT-120115 - Breeze - Order Book - Good Till Date - Start
const OrdersSpreadPopover = ({ children, placement = 'right', objRowData, activeContent, ...props }) => {
    //Maaz A : 08-11-2023 : BT-120115 - Breeze - Order Book - Good Till Date - End
    // console.log('objRowData', objRowData);
    // const objRowData = ORDERS_GRID_REF?.current?.props?.rowData?.filter(ele => ele?.orderNo === objRowData?.orderNo)?.[0];
    const dispatch = useDispatch();
    const [showPopover, setShowPopover] = useState(false);
    const [objScripData, setObjScripData] = useState({});
    const [currentHolding, setCurrentHolding] = useState([]);
    const [holdingInfo, setHoldingInfo] = useState([]);
    const holdingsScrips = useSelector(state => state.holdings?.holdingsScrips);
    //Azeem K : 06-03-2024 : BT-102298 - Breeze - Single Scrip Order entry - All segments - Start
    const bIsMultipleOrdersCancelinProcess = useSelector(state => state.orders?.bIsMultipleOrdersCancelinProcess);
    //Azeem K : 06-03-2024 : BT-102298 - Breeze - Single Scrip Order entry - All segments - End
    const objCFT = useSelector(state => state?.auth?.objCFT);//ManasaB : 23/11/2023 : BT-115296 Calculator Bug Fixing
    const showTradeInfo = (orderNo) => {
        setShowPopover(false);
        ORDERS_GRID_REF.current.api.forEachNode(node => {
            if (node?.data?.orderNo === orderNo) {
                ORDERS_GRID_REF.current.api.setRowNodeExpanded(node, true, true);
            }
        });
    };
    //Azeem K : 16-12-2023 :BT-101818 : Order Book - Single Scrip Order  ---Start
    useEffect(() => {
        if (holdingsScrips?.length) {
            holdingsScrips?.forEach((item, i) => {
                //Vaibhav Singh: Holding icon removed from order book: Start
                if (item?.TOTALFREEQUANTITY !== "0" && item['ISIN'] === objRowData?.sISINCode && objRowData?.instrument === SCRIP_INSTRUMENTS.EQUITIES
                ) {
                    setCurrentHolding([item]);
                }
            });
        }
    }, [holdingsScrips, objRowData]);
    // Azeem K : 16-12-2023 :BT-101818 : Order Book - Single Scrip Order  ---End
    useEffect(() => {
        if (currentHolding?.length) {
            if (currentHolding[0]?.nBuyAvgPrice) {
                let arrNetChangePNL = getChangeInRs((objScripData?.ltp * currentHolding[0]['TOTALFREEQUANTITY']).toFixed(2), (parseFloat(currentHolding[0]?.nBuyAvgPrice) * parseInt(currentHolding[0]?.TOTALFREEQUANTITY)).toFixed(2), 2, false, 'uptrend');
                setHoldingInfo(arrNetChangePNL);
            }
        }
    }, [currentHolding, objScripData]);

    //ManasaB : 13-06-2024 : Changed to left click in grid :Start
    const leftClick = useCallback((e) => {
        if (e?.button === 0) {
            setShowPopover(false);
        }
    }, []);
    const [targetobjRowData] = useLeftClick(leftClick);
    //ManasaB : 13-06-2024 : Changed to left click in grid : End
    const onContextMenu = (e) => {
        if (e?.ctrlKey) {
            return;
        }
        e.preventDefault();
        //Azeem K : 06-03-2024 : BT-102298 - Breeze - Single Scrip Order entry - All segments - Start
        if (!bIsMultipleOrdersCancelinProcess) {
            setShowPopover(true);
        }
        //Azeem K : 06-03-2024 : BT-102298 - Breeze - Single Scrip Order entry - All segments - End
    };

    // useEffect(() => {
    //     if (location?.state?.length > 0) {
    //         const nIndex = ORDERS_GRID_REF?.current?.api?.getRowNode(location?.state)?.rowIndex;
    //         ORDERS_GRID_REF?.current?.api?.getDisplayedRowAtIndex(nIndex)?.setSelected(true);
    //         ORDERS_GRID_REF?.current?.api?.getDisplayedRowAtIndex(nIndex).setExpanded(true);
    //         setShowPopover(false);
    //     } else { }
    // }, [location.state]);



    useEffect(() => {
        const objLastTickData = dispatch(getWfhTouchlineLastTick());
        const arrLastTickData = objLastTickData[objRowData?.mktId + '_' + objRowData?.scripToken];
        if (arrLastTickData) {
            let nAbsPrevColse = arrLastTickData[TL_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE];
            setObjScripData({
                ltp: arrLastTickData[TL_INDEX.LAST_TRADE_PRICE],
                //Maaz A : 04-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSECDS Bug Fixes - Start
                changeInPrice: nAbsPrevColse,
                //Maaz A : 04-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSECDS Bug Fixes - End
                changeInPercent: arrLastTickData[TL_INDEX.NET_CHANGE_FROM_PRE_CLOSE]
            });
        }
        // Azeem K : 09-11-2023 :BT-101818 : Order Book - Single Scrip Order – Issue - LTP and change in price not displaying – Start
        else {
            setObjScripData({
                ltp: parseFloat(0).toFixed(objRowData?.decimalLocatorLength),
                changeInPrice: parseFloat(0).toFixed(objRowData?.decimalLocatorLength),
                changeInPercent: '0.00'
            });
        }
        // Azeem K : 09-11-2023 :BT-101818 : Order Book - Single Scrip Order – Issue - LTP and change in price not displaying – End


    }, [dispatch, objRowData]);

    //Maaz A : 09-11-2023 : BT-120115 - Breeze - Order Book - Good Till Date - Start
    useWFHMessages('touchline', (e) => {
        const arrTouchlineData = [...e.detail];
        if (arrTouchlineData[TL_INDEX.SEGMENT_ID] === objRowData?.mktId && arrTouchlineData[TL_INDEX.TOKEN] === objRowData?.scripToken) {
            let nAbsPrevColse = arrTouchlineData[TL_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE];
            setObjScripData({
                ltp: arrTouchlineData[TL_INDEX.LAST_TRADE_PRICE],
                changeInPrice: nAbsPrevColse,
                changeInPercent: arrTouchlineData[TL_INDEX.NET_CHANGE_FROM_PRE_CLOSE]
            });
        }
    });
    //Maaz A : 09-11-2023 : BT-120115 - Breeze - Order Book - Good Till Date - End

    // const handleSquareOffPosition = useCallback(() => {
    //     setShowPopover(false);

    //     dispatch(handleModalData({ data: objRowDataFromGrid, type: 'Single Square Off' }));
    //     dispatch(handleModal([{ "ORDER_DETAILS_MODAL": true }], true));
    // }, [objRowDataFromGrid, dispatch]);
    // Azeem K : 07-12-2023 :BT-101818 : Order Book - Single Scrip Order  ---Start
    const bIsCancelButton = useMemo(() => {
        return objRowData?.status === ORDER_STATUS_FROM_RESPONSE.PENDING || objRowData?.status === ORDER_STATUS_FROM_RESPONSE.PARTIALLYCOMPLETED_MAIN || objRowData?.status === ALL_ORDERS_STATUS.PARTIALLY_COMPLETED || objRowData?.status === ORDER_STATUS_FROM_RESPONSE.OMS_XMITTED || objRowData?.status === ORDER_STATUS_FROM_RESPONSE.OMSXMITTED_MAIN || objRowData?.status === ORDER_STATUS_FROM_RESPONSE.ACTIVE || objRowData?.status === ORDER_STATUS_FROM_RESPONSE.AMOACCEPTED || objRowData?.status === ORDER_STATUS_FROM_RESPONSE.AMOACCEPTED_MAIN;
    }, [objRowData]);

    const bIsModifyButton = useMemo(() => {
        return objRowData?.status === ORDER_STATUS_FROM_RESPONSE.PENDING || objRowData?.status === ORDER_STATUS_FROM_RESPONSE.PARTIALLYCOMPLETED_MAIN || objRowData?.status === ORDER_STATUS_FROM_RESPONSE.AMOACCEPTED_MAIN || objRowData?.status === ORDER_STATUS_FROM_RESPONSE.ACTIVE;
    }, [objRowData]);
    // Azeem K : 07-12-2023 :BT-101818 : Order Book - Single Scrip Order  ---End


    // const bIsSquareOffButton = useMemo(() => {
    //     return objRowDataFromGrid?.status === ALL_ORDERS_STATUS.ORDER_STATUS_COMPLETED || objRowDataFromGrid?.status === ALL_ORDERS_STATUS.ORDER_STATUS_EXECUTED;
    // }, [objRowDataFromGrid]);

    const handleModifyOrder = useCallback(async () => {
        let tempData = [];
        let arr = Array(Object.keys(WATCHLIST_GRID_INDEX)?.length)?.fill('0');
        arr[WATCHLIST_GRID_INDEX.SYMBOL] = objRowData?.spread_symbol;
        arr[WATCHLIST_GRID_INDEX.EXPIRYDATE] = objRowData?.leg_no_1?.expiry_date;
        arr[WATCHLIST_GRID_INDEX.EXCHANGE] = objRowData?.exchange;
        arr[WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT] = objRowData?.exchange;
        arr[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH] = objRowData?.leg_no_1?.dec_loc.length - 1;
        arr[WATCHLIST_GRID_INDEX.INSTRUMENT] = objRowData?.leg_no_1.instrument;
        arr[WATCHLIST_GRID_INDEX.SEGMENT_ID] = objRowData?.segment_id;
        arr[WATCHLIST_GRID_INDEX.ASSET_TOKEN] = objRowData?.spread_token;
        arr[WATCHLIST_GRID_INDEX.TOKEN] = objRowData?.spread_token;
        arr[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR] = objRowData?.leg_no_1?.dec_loc;
        arr[WATCHLIST_GRID_INDEX.NSPREAD] = 1;
        arr[WATCHLIST_GRID_INDEX.MAPPED_SEGMENT_ID] = getMappedMktSegIdFromApiExchangeName(objRowData?.exchange);
        arr[WATCHLIST_GRID_INDEX.OPTIONTYPE] = objRowData?.leg_no_1.option_type === 'XX' ? "" : objRowData?.leg_no_1.option_type;
        arr[WATCHLIST_GRID_INDEX.STRIKEPRICE] = objRowData?.leg_no_1.strike_price <= 0 ? "" : objRowData?.leg_no_1.strike_price;
        arr[WATCHLIST_GRID_INDEX.REGULAR_LOT] = objRowData?.leg_no_1.market_lot;
        arr[WATCHLIST_GRID_INDEX.PRICE_TICK] = parseFloat(+objRowData?.leg_no_1.price_tick / +objRowData?.leg_no_1.dec_loc);
        arr[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH] = parseFloat(+objRowData?.leg_no_1.price_tick / +objRowData?.leg_no_1.dec_loc)?.toString()?.split('.')[1]?.length;
        arr[WATCHLIST_GRID_INDEX.PRICE_QUOTATION_UNIT] = "Qty";
        var spreadPaylod =
        {
            "mktSegid": getMappedMktSegIdFromApiExchangeName(getApiExchangeNameFromMktSegId(arr[WATCHLIST_GRID_INDEX.SEGMENT_ID])),//Ameersha N - 04-03-2024 - Sending Mapped Market Segment ID for spread API,
            "symbol": arr[WATCHLIST_GRID_INDEX.SYMBOL],
            "token": arr[WATCHLIST_GRID_INDEX.TOKEN]
        };
        const objResp = await dispatch(getSpreadOrder(spreadPaylod));
        tempData = objResp?.data?.data.map((x, i) => {
            return {
                ...x,
                nQuantity: objRowData?.exchange === "NSECDS" || objRowData?.exchange === "BSECDS" ? objRowData?.leg_no_1?.pending_quantity : objRowData?.leg_no_1?.pending_quantity / objRowData?.leg_no_1?.market_lot,
                nPrice: objRowData?.leg_no_1?.order_price,
                nTransactionType: i === 0 ? objRowData?.leg_no_1?.transaction_type : objRowData?.leg_no_2?.transaction_type
            };
        });
        const objScrpinfo = { activeExchangeId: MARKET_SEGMENT_ID.NSE_CASH, isBuySell: 0, scripData: arr, isModifyOrder: true };
        dispatch(getScripOrderInfo(objScrpinfo));
        dispatch(getSpreadOrderSuccess(tempData));

        // let leg1 = getLegObject({ ...data?.leg_no_1, exchange: data?.exchange }, WATCHLIST_GRID_INDEX, 1, true)
        // let leg2 = getLegObject({ ...data?.leg_no_2, exchange: data?.exchange }, WATCHLIST_GRID_INDEX, 2, true)
        // tempData.push(leg1, leg2)
        // tempData[0].extraInfo = tempData[1].extraInfo = [...arr];

        // let list = await _getExpiryForScrip(whatsHotData, { segment_id: arr?.[WATCHLIST_GRID_INDEX?.SEGMENT_ID], symbol: arr?.[WATCHLIST_GRID_INDEX.SYMBOL], instrument: arr?.[WATCHLIST_GRID_INDEX.INSTRUMENT] === SCRIP_INSTRUMENTS.EQUITIES ? SCRIP_INSTRUMENTS.FUTSTK : arr?.[WATCHLIST_GRID_INDEX.INSTRUMENT] });
        // tempData[0].expiryList = tempData[1].expiryList = [...list];
        // tempData[0]["selectedExpiry"] = list.find(el => el.nExpiryDate1 === moment(tempData[0]?.expiryDate, 'YYYY-MM-DD').format('DDMMMYYYY').toUpperCase());
        // tempData[1]["selectedExpiry"] = list.find(el => el.nExpiryDate1 === (moment(tempData[1]?.expiryDate, 'YYYY-MM-DD').format('DDMMMYYYY').toUpperCase()));
        // dispatch(getMultiLegData(tempData))
        setShowPopover(false);

        setTimeout(() => {
            dispatch(handleModal([{ 'ORDER_ENTRY_MODAL': true }, true]));
            // {/* Vinit Raut : 27-03-2024 : BT-107418 -  Breeze – SIP Order entry bug fixing BT-102676 -- Start  */ }
            dispatch(handleModalData({ data: { spreadArr: arr, orderEntryTab: 'multi_scrip', activeTabKey: 'spread', isModifyOrder: true, gatewayOrderNo: objRowData?.gateway_order_no, orderTime: objRowData?.ordertime, isRL: true }, orderType: ORDER_TYPES.MULTI_LEG }), true);
            // {/* Vinit Raut : 27-03-2024 : BT-107418 -  Breeze – SIP Order entry bug fixing BT-102676 -- End */ }
        }, 300);


        // dispatch(handleModal([{ 'ORDER_ENTRY_MODAL': true }, true]));
    }, [dispatch, objRowData]);

    const handleCancelOrder = useCallback(() => {
        function getObj(params, lgNo) {
            if (params.scrip_token === null) return {};
            return {
                legNumber: lgNo,
                segmentId: objRowData?.segment_id,
                exchange: objRowData?.exchange,
                activeButtonToggleIndex: params?.transaction_type === 'BUY' ? 0 : 1,
                transaction_type: params?.transaction_type,
                token: params?.scrip_token,
                symbol: params?.symbol,
                expiryDate: params?.expiry_date,
                strikePrice: params?.strike_price,
                optiontype: 'XX',
                instrument: params?.instrument,
                quantity: params?.total_quantity,
                totalQuantity: params?.total_quantity,
                pendingQuantity: params?.pending_quantity,
                ask_qty: params?.market_lot,
                legPrice: params?.order_price,
                price: params?.order_price,
                priceTick: params?.price_tick,
                decLoc: params?.dec_loc,
                gatewayOrderNo: objRowData?.gateway_order_no,
                timestamp: objRowData?.ordertime
            };
        }
        let temp = [];
        temp.push(getObj(objRowData.leg_no_1, 1), getObj(objRowData.leg_no_2, 2));
        dispatch(getOrderInfo(temp));
        setShowPopover(false);

        dispatch(handleModal([{ 'CANCEL_ORDER_MODAL': true }], true));
    }, [objRowData, dispatch]);

    const handleReOrder = async () => {
        let tempData = [];
        let arr = Array(Object.keys(WATCHLIST_GRID_INDEX)?.length)?.fill('0');
        arr[WATCHLIST_GRID_INDEX.SYMBOL] = objRowData?.spread_symbol;
        arr[WATCHLIST_GRID_INDEX.EXPIRYDATE] = objRowData?.leg_no_1?.expiry_date;
        arr[WATCHLIST_GRID_INDEX.EXCHANGE] = objRowData?.exchange;
        arr[WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT] = objRowData?.exchange;
        // arr[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH] = objRowData?.leg_no_1?.dec_loc.length - 1;
        arr[WATCHLIST_GRID_INDEX.INSTRUMENT] = objRowData?.leg_no_1.instrument;
        arr[WATCHLIST_GRID_INDEX.SEGMENT_ID] = objRowData?.segment_id;
        arr[WATCHLIST_GRID_INDEX.ASSET_TOKEN] = objRowData?.spread_token;
        arr[WATCHLIST_GRID_INDEX.TOKEN] = objRowData?.spread_token;
        arr[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR] = objRowData?.leg_no_1?.dec_loc;
        arr[WATCHLIST_GRID_INDEX.NSPREAD] = 1;
        arr[WATCHLIST_GRID_INDEX.MAPPED_SEGMENT_ID] = getMappedMktSegIdFromApiExchangeName(objRowData?.exchange);
        arr[WATCHLIST_GRID_INDEX.OPTIONTYPE] = objRowData?.leg_no_1.option_type === 'XX' ? "" : objRowData?.leg_no_1.option_type;
        arr[WATCHLIST_GRID_INDEX.STRIKEPRICE] = objRowData?.leg_no_1.strike_price <= 0 ? "" : objRowData?.leg_no_1.strike_price;
        arr[WATCHLIST_GRID_INDEX.REGULAR_LOT] = objRowData?.leg_no_1.market_lot;
        arr[WATCHLIST_GRID_INDEX.PRICE_TICK] = parseFloat(+objRowData?.leg_no_1.price_tick / +objRowData?.leg_no_1.dec_loc);
        arr[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH] = parseFloat(+objRowData?.leg_no_1.price_tick / +objRowData?.leg_no_1.dec_loc)?.toString()?.split('.')[1]?.length;
        arr[WATCHLIST_GRID_INDEX.PRICE_QUOTATION_UNIT] = "Qty"; // hardcoded as need to discuss with backend
        var spreadPaylod =
        {
            "mktSegid": getMappedMktSegIdFromApiExchangeName(getApiExchangeNameFromMktSegId(arr[WATCHLIST_GRID_INDEX.SEGMENT_ID])),//Ameersha N - 04-03-2024 - Sending Mapped Market Segment ID for spread API,
            "symbol": arr[WATCHLIST_GRID_INDEX.SYMBOL],
            "token": arr[WATCHLIST_GRID_INDEX.TOKEN]
        };
        let objResp = await dispatch(getSpreadOrder(spreadPaylod));
        tempData = objResp?.data?.data.map((x, i) => {
            return {
                ...x,
                nQuantity: objRowData?.exchange === "NSECDS" || objRowData?.exchange === "BSECDS" ? objRowData?.leg_no_1?.total_quantity : objRowData?.leg_no_1?.total_quantity / objRowData?.leg_no_1?.market_lot,
                nPrice: +objRowData?.leg_no_1?.order_price,
                nTransactionType: i === 0 ? objRowData?.leg_no_1?.transaction_type : objRowData?.leg_no_2?.transaction_type
            };
        });
        const objScrpinfo = { activeExchangeId: MARKET_SEGMENT_ID.NSE_CASH, isBuySell: 0, scripData: arr };
        dispatch(getScripOrderInfo(objScrpinfo));
        dispatch(getSpreadOrderSuccess(tempData));

        // let leg1 = getLegObject({ ...data?.leg_no_1, exchange: data?.exchange }, WATCHLIST_GRID_INDEX, 1, true)
        // let leg2 = getLegObject({ ...data?.leg_no_2, exchange: data?.exchange }, WATCHLIST_GRID_INDEX, 2, true)
        // tempData.push(leg1, leg2)
        // tempData[0].extraInfo = tempData[1].extraInfo = [...arr];

        // let list = await _getExpiryForScrip(whatsHotData, { segment_id: arr?.[WATCHLIST_GRID_INDEX?.SEGMENT_ID], symbol: arr?.[WATCHLIST_GRID_INDEX.SYMBOL], instrument: arr?.[WATCHLIST_GRID_INDEX.INSTRUMENT] === SCRIP_INSTRUMENTS.EQUITIES ? SCRIP_INSTRUMENTS.FUTSTK : arr?.[WATCHLIST_GRID_INDEX.INSTRUMENT] });
        // tempData[0].expiryList = tempData[1].expiryList = [...list];
        // tempData[0]["selectedExpiry"] = list.find(el => el.nExpiryDate1 === moment(tempData[0]?.expiryDate, 'YYYY-MM-DD').format('DDMMMYYYY').toUpperCase());
        // tempData[1]["selectedExpiry"] = list.find(el => el.nExpiryDate1 === (moment(tempData[1]?.expiryDate, 'YYYY-MM-DD').format('DDMMMYYYY').toUpperCase()));
        // dispatch(getMultiLegData(tempData))
        setShowPopover(false);
        setTimeout(() => {

            dispatch(handleModal([{ 'ORDER_ENTRY_MODAL': true }, true]));
            dispatch(handleModalData({ data: { spreadArr: arr, orderEntryTab: 'multi_scrip', activeTabKey: 'spread', isRL: true } }), true);
        }, 300);
    };

    const handleOverview = async () => {
        setShowPopover(false);
        let arr = Array(Object.keys(WATCHLIST_GRID_INDEX)?.length)?.fill('0');
        arr[WATCHLIST_GRID_INDEX.SYMBOL] = objRowData?.spread_symbol;
        arr[WATCHLIST_GRID_INDEX.EXPIRYDATE] = objRowData?.leg_no_1?.expiry_date;
        arr[WATCHLIST_GRID_INDEX.EXCHANGE] = objRowData?.exchange;
        arr[WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT] = objRowData?.exchange === 'NSECDS' ? "NSE_CUR" : objRowData?.exchange === 'BSECDS' ? "BSE_CUR" : objRowData?.exchange;
        // arr[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH] = objRowData?.leg_no_1?.dec_loc.length - 1;
        arr[WATCHLIST_GRID_INDEX.INSTRUMENT] = objRowData?.leg_no_1.instrument;
        arr[WATCHLIST_GRID_INDEX.SEGMENT_ID] = objRowData?.segment_id;
        arr[WATCHLIST_GRID_INDEX.ASSET_TOKEN] = objRowData?.spread_token;
        arr[WATCHLIST_GRID_INDEX.TOKEN] = objRowData?.spread_token;
        arr[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR] = objRowData?.leg_no_1?.dec_loc;
        arr[WATCHLIST_GRID_INDEX.NSPREAD] = 1;
        arr[WATCHLIST_GRID_INDEX.MAPPED_SEGMENT_ID] = getMappedMktSegIdFromApiExchangeName(objRowData?.exchange === 'NSECDS' ? "NSE_CUR" : objRowData?.exchange === 'BSECDS' ? "BSE_CUR" : objRowData?.exchange);
        arr[WATCHLIST_GRID_INDEX.OPTIONTYPE] = objRowData?.leg_no_1.option_type === 'XX' ? "" : objRowData?.leg_no_1.option_type;
        arr[WATCHLIST_GRID_INDEX.STRIKEPRICE] = objRowData?.leg_no_1.strike_price <= 0 ? "" : objRowData?.leg_no_1.strike_price;
        arr[WATCHLIST_GRID_INDEX.REGULAR_LOT] = objRowData?.leg_no_1.market_lot;
        arr[WATCHLIST_GRID_INDEX.PRICE_TICK] = parseFloat(+objRowData?.leg_no_1.price_tick / +objRowData?.leg_no_1.dec_loc);
        arr[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH] = parseFloat(+objRowData?.leg_no_1.price_tick / +objRowData?.leg_no_1.dec_loc)?.toString()?.split('.')[1]?.length;
        const scripDataRes = await _getScripsInfo([{ mkt: arr?.[WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT], token: arr?.[WATCHLIST_GRID_INDEX.TOKEN] }]);
        const scripDataObj = scripDataRes?.data?.objScripsResp?.result;
        const scripData = convertScripResponseWatchlistGrid(scripDataObj);
        sendBestFiveRequest({ exchangeId: scripData?.[0]?.[WATCHLIST_GRID_INDEX.SEGMENT_ID], token: scripData?.[0]?.[WATCHLIST_GRID_INDEX.TOKEN], isSubscribe: true });
        dispatch(setScripOverviewData(scripData?.[0]));
        dispatch(handleModal([{ 'MARKET_OVERVIEW_MODAL': true }]));
    };
    const handleSetAlert = () => {

        setShowPopover(false);
        dispatch(handleModalData({
            AlertData: {
                symbol: objRowData?.title,
                exchange: objRowData?.exchange?.split('_')[0],
                series: objRowData?.series,
                // description: scrip[WATCHLIST_GRID_INDEX.SECURITY_DESCRIPTION],
                token: objRowData?.scripToken,
                mktId: objRowData?.mktId,
                decimalLocator: getDecimalLocatorFromApiExchangeName(objRowData?.exchange),
                decimalLocator_length: getDynamicParamsForToFixed(objRowData?.exchange),
                exchange_segement: objRowData?.exchangeSegment,
                expiryDate: `${objRowData?.expiryRange} ${moment(objRowData?.leg_no_1?.expiry_date).format("DD MMM 'YY").toUpperCase()}`,
                instrument: objRowData?.instrument
            },
            isShowAlerts: true
        }));
        dispatch(handleModal([{ "SET_ALERT_MODAL": true }]));
    };
    const BzPopover = (
        <Popover className='scripdetails-popover'>
            <Popover.Header>
                <div className='p-2'>
                    <Row className='g-0'>
                        <Col md={8}>
                            <Row className='g-0'>
                                <Col className='d-flex align-items-center'>
                                    <div className='font-medium font-size4 color-text text-truncate me-2'>{objRowData?.title}</div>
                                    <div className='chips-wrap'>
                                        <BzChip className='exchange-chip text-truncate'>{objRowData?.exchange?.split('_')[0]}</BzChip>
                                    </div>
                                </Col>
                            </Row>
                            <Row className='g-0'>
                                <Col className='d-flex justify-content-start'>
                                    <div className='font-regular font-size3 color-subtext'>
                                        {/* <OrderDisplayDescription objRowData={objRowData} /> */}
                                        {/* Parshva S : 20/03/2024 : BT 107070 Breeze Spread Orders Start */}
                                        <div className='font-regular font-enlarge color-subtext'>{`${objRowData?.expiryRange} ${moment(objRowData?.leg_no_1?.expiry_date).format("DD MMM 'YY").toUpperCase()} ${objRowData?.instrument?.slice(0, 3)} `}</div>
                                        {/* Parshva S : 20/03/2024 : BT 107070 Breeze Spread Orders End */}
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                        <Col md={4}>
                            <Row className='g-0'>
                                <Col className='flex-column justify-content-start align-items-end text-end'>
                                    <div className='font-medium font-size4 color-text'>{objScripData?.ltp}</div>
                                    <div className={`font-regular font-size2 color-text color-${objScripData?.changeInPrice?.split('')[0] === '+' ? 'positive' : objScripData?.changeInPrice?.split('')[0] === '-' ? 'negative' : ''} ms-1`} >{objScripData?.changeInPrice} ({objScripData?.changeInPercent}%)</div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </div>
            </Popover.Header>
            <Popover.Body className='d-flex flex-column'>
                <div className='bdr-top bdr-btm'>
                    {/* Azeem k :09-11-2023 :code commented as per discussion with akshay square off will be remove code will remove later */}
                    {/* {bIsSquareOffButton && <Row Row className='g-0 py-2 popover-menu' onClick={handleSquareOffPosition}>
                        <Col className='d-flex align-items-center'>
                            <div className='icon-16 icon-square-off icon-dark'></div>
                            <div className='font-regular font-size4 color-text ms-2'>Square Off</div>
                        </Col>
                    </Row>} */}
                    {bIsModifyButton && <Row className='g-0 py-2 popover-menu'>
                        <Col className='d-flex align-items-center' onClick={handleModifyOrder}>
                            <div className='icon-16 icon-edit icon-dark'></div>
                            <div className='font-regular font-size4 color-text ms-2'>Modify order</div>
                        </Col>
                    </Row>}
                    {bIsCancelButton && <Row Row className='g-0 py-2 popover-menu' onClick={handleCancelOrder}>
                        <Col className='d-flex align-items-center'>
                            <div className='icon-16 icon-close icon-dark'></div>
                            <div className='font-regular font-size4 color-text ms-2'>Cancel order</div>
                        </Col>
                    </Row>}
                    <Row className='g-0 py-2 popover-menu' onClick={handleReOrder}>
                        <Col className='d-flex align-items-center'>
                            <div className='icon-16 icon-reorder icon-dark'></div> {/* Hari P: SAT-BT-120115: 08-12-23- UI Issue Fixed */}
                            <div className='font-regular font-size4 color-text ms-2'>Reorder</div>
                        </Col>
                    </Row>
                    <Row className='g-0 py-2 popover-menu' onClick={showTradeInfo.bind(this, objRowData?.orderNo)}>
                        <Col className='d-flex align-items-center'>
                            <div className='icon-16 icon-info icon-dark'></div>
                            <div className='font-regular font-size4 color-text ms-2'>
                                {/* Maaz A : 08-11-2023 : BT-120115 - Breeze - Order Book - Good Till Date - Start */}
                                {activeContent === ORDER_TYPES.GOOD_TILL_DATE ? 'Order History' : 'Trade Information'}
                                {/* Maaz A : 08-11-2023 : BT-120115 - Breeze - Order Book - Good Till Date - End */}
                            </div>
                        </Col>
                    </Row>
                    <Row className='g-0 py-2 popover-menu' onClick={handleOverview}>
                        <Col className='d-flex align-items-center'>
                            <div className='icon-16 icon-overview icon-dark'></div>
                            <div className='font-regular font-size4 color-text ms-2'>Overview</div>
                        </Col>
                    </Row>
                    {
                        objCFT.ALERT === FACILITY_NUM.ON ?
                            <Row className='g-0 py-2 popover-menu' onClick={handleSetAlert}>
                                <Col className='d-flex align-items-center'>
                                    {/* ManasaB : 23/11/2023 : BT-115296 Calculator Bug Fixing - Start */}
                                    <>
                                        <div className='icon-16 icon-bell icon-dark'></div>
                                        <div className='font-regular font-size4 color-text ms-2'>Set Alerts</div>
                                    </>
                                </Col>
                                {/* ManasaB : 23/11/2023 : BT-115296 Calculator Bug Fixing - End */}
                            </Row> : null
                    }
                </div>
                <div className='px-2 pb-2'>
                    {currentHolding?.length > 0 && <Row className='g-0 py-2 cursor-pointer'>
                        <Col className='d-flex align-items-center'>
                            <div className='icon-16 icon-portfolio icon-dark'></div>
                            <div className='font-regular font-size3 color-text ms-2'>{currentHolding[0]?.TOTALFREEQUANTITY}</div>
                            {/* Azeem K : 16-12-2023 :BT-101818 : Order Book - Single Scrip Order  ---Start  */}
                            <div className='font-regular font-size3 color-text ms-2'>{(holdingInfo?.length) ? <span className={`font-regular font-size3 color-text ${holdingInfo[2]}`}>&#8377;{`${Number(holdingInfo[0])?.toLocaleString('en-IN', { minimumFractionDigits: 2 })}(${holdingInfo[1]})`}</span> : null}</div>
                            {/* Azeem K : 16-12-2023 :BT-101818 : Order Book - Single Scrip Order  ---End  */}

                        </Col>
                    </Row>}
                    {objRowData?.dontMiss?.length > 0 &&
                        <Row className='g-0 py-2'>
                            <Col className='d-flex align-items-center'>
                                <div className='icon-16 icon-dontmiss icon-yellow'></div>
                                <div className='chips-wrap ms-2'>
                                    <DontMissChip value={objRowData.dontMiss} />
                                </div>
                            </Col>
                        </Row>}
                </div>
            </Popover.Body>
        </Popover>

    );
    return (
        // Azeem K : 15-11-2023 :BT-101818 : Order Book - Single Scrip Order  ---Start
        <BzPopoverOverlay show={showPopover} rootClose trigger='click' placement={placement} popover={BzPopover} onToggle={() => setShowPopover(false)}>
            {/* Azeem K : 15-11-2023 :BT-101818 : Order Book - Single Scrip Order  ---End */}

            {/* Vinit Raut : 28-11-2023 : BT-102298 - Breeze - NSECDS UI fixes -- Start */}
            {/* ManasaB : 13-06-2024 : Changed to left click in grid : Start */}
            <div className='scrip-wrap text-center' ref={targetobjRowData} onClick={onContextMenu}>{children}</div>
            {/* ManasaB : 13-06-2024 : Changed to left click in grid : End */}
            {/* Vinit Raut : 28-11-2023 : BT-102298 - Breeze - NSECDS UI fixes -- End */}
        </BzPopoverOverlay>
    );

};
export default memo(OrdersSpreadPopover);
// Parshva S : 14/03/2024 : BT107070 Breeze Spread Orders End